/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/newspaper'
export default icon
